import * as React from 'react'
import Stack from '@eversports/klimt-primitives/Stack'

import ContainedXLWidthContainer from '../ContainedXLWidthContainer'
import EversportsFlywheelLinks from '../EversportsFlywheelLinks'

import StaticFooterComponent from './StaticFooterComponent'
import CopyrightAndPaymentMethods from './CopyrightAndPaymentMethods'

const Footer = () => (
  <Stack
    component="footer"
    sx={{
      position: 'relative',
      overflow: 'hidden',
      zIndex: 2,
      contentVisibility: 'auto',
      backgroundColor: 'midnight',
    }}
  >
    <ContainedXLWidthContainer>
      <Stack sx={{ flexDirection: { sm: 'row' }, gap: 4, paddingX: 4, paddingY: 6 }}>
        <EversportsFlywheelLinks />
      </Stack>
      <StaticFooterComponent />
      <CopyrightAndPaymentMethods />
    </ContainedXLWidthContainer>
  </Stack>
)

export default Footer
